import React, { useEffect } from "react";
import { Button, message } from "antd";
import { AlreadyCollectSearchBox } from "./SearchBox";
import { AlreadyCollectDataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useAlreadyCollectModel } from "./alreadyCollectModel";
import { CollectDetailDrawer } from "./CollectDetailDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const AlreadyCashCollect = () => {
  const {
    dataSource,
    selectedRowKeys,
    setCollectDrawerVisible,
    setSelectedData,
    loadData,
  } = useAlreadyCollectModel();

  useEffect(() => {
    loadData({ pageNum: 1 }).then()
  }, [])

  useEffect(() => {
    let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.key === selectedRowKeys[0] : false);
    const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
    setSelectedData(selectedData)
  }, [selectedRowKeys]);

  const onOpenAccount = () => {
    if (selectedRowKeys && selectedRowKeys.length > 0) {
      setCollectDrawerVisible(true);
    } else {
      message.error("请选择收款账单!");
    }
  }

  const action = (
    <div>
      {/* <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={() => { }}
        >
          导出
        </Button> */}
      <YhAuth resCode={ResourceAuthEnum.CASH_RECEI_DONE_VW}>
        <Button
          className="mr-5"
          type="link"
          shape="round"
          onClick={onOpenAccount}
        >
          查看支付明细
        </Button>
      </YhAuth>
    </div>
  );

  return (
    <>
      <AlreadyCollectSearchBox />
      <YhBox title={"已收列表"} action={action}>
        <AlreadyCollectDataTable />
      </YhBox>
      <CollectDetailDrawer />
    </>
  )
}

